module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9fcMVT/tc-custom/9781460327340.jpg?1740292047000",
      "alt": "This image is the cover for the book Double the Trouble, Billionaires and Babies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Double the Trouble, Billionaires and Babies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One night with a billionaire leads to two beautiful babies and a whole heap of trouble in the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author’s charming and sexy romance.")]), _c('br'), _c('br'), _vm._v("When billionaire Colton King ended his impetuous marriage to Penny Oaks after just twenty-four hours, he wanted to put the whole things out of his mind for good. But now, more than a year later, Colton discovers Penny’s huge secret—actually two little secrets: a baby boy and a baby girl. "), _c('br'), _c('br'), _vm._v("Colton’s only option is to lay claim to his twins. But soon he finds himself laying claim to Penny all over again. Now they have to ask themselves: Was their whirlwind marriage meant to last a lifetime?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maureen Child\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Maureen Child is the author of more than 130 romance novels and novellas that routinely appear on bestseller lists and have won numerous awards, including the National Reader's Choice Award. A seven-time nominee for the prestigous RITA award from Romance Writers of America, one of her books was made into a CBS-TV movie called THE SOUL COLLECTER.  Maureen recently moved from California to the mountains of Utah and is trying to get used to snow.   ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0